import { LoadingButton } from '@mui/lab'
import { Box, Card, TextField, Typography } from '@mui/material'
import { t } from 'i18next'
import React, { useEffect, useState } from 'react'

type CommentSectionProps = {
    updateComment: (comment: string) => void,
    defaultComment?: string,
    isCommentUpdating: boolean

}

function CommentSection({ updateComment, defaultComment,isCommentUpdating }: CommentSectionProps) {
    const [comment, setComment] = useState('')

    useEffect(() => {
        setComment(defaultComment ?? '')
    }, [defaultComment])
    return (
        <Card sx={{ p: 2, minHeight: '100%' }}>
            <Typography variant='h6'>{t('editTrainingForm:comment:label')}</Typography>
            <Box mt={2} display={'flex'} flexDirection={'column'} flex={1} justifyContent={'space-between'} >
                <TextField value={comment} rows={4} onChange={e => setComment(e.target.value)} multiline label={t('editTrainingForm:comment:label')} fullWidth></TextField>
                <LoadingButton loading={isCommentUpdating} onClick={() => updateComment(comment)} sx={{ alignSelf: 'end', mt: 1 }} variant='contained'>Save</LoadingButton>
            </Box>
        </Card>
    )
}

export default CommentSection